import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPNameSectionUI from './PDPNameSectionUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
import PDPNameSectionPlaceholder from './PDPNameSectionPlaceholder';
const PDPNameSectionInner = t0 => {
  const $ = _c(19);
  const {
    isEditOrder: t1,
    disableStickyPriceRow: t2,
    hideProductLabel: t3,
    hideRatings: t4
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const disableStickyPriceRow = t2 === undefined ? false : t2;
  const hideProductLabel = t3 === undefined ? false : t3;
  const hideRatings = t4 === undefined ? false : t4;
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    loading,
    error,
    data
  } = usePDPBasicDetails();
  if (!data && loading) {
    let t5;
    if ($[0] !== disableStickyPriceRow || $[1] !== hideProductLabel || $[2] !== hideRatings) {
      t5 = <PDPNameSectionUI loading={true} disableStickyPriceRow={disableStickyPriceRow} hideProductLabel={hideProductLabel} hideRatings={hideRatings} />;
      $[0] = disableStickyPriceRow;
      $[1] = hideProductLabel;
      $[2] = hideRatings;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    return t5;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  let t5;
  if ($[4] !== data) {
    t5 = data ?? {};
    $[4] = data;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    name: t6
  } = t5;
  const name = t6 === undefined ? "" : t6;
  let t7;
  if ($[6] !== data?.attributes) {
    t7 = data?.attributes?.filter(_temp)[0]?.value;
    $[6] = data?.attributes;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const subtitle = t7;
  let t8;
  if ($[8] !== name || $[9] !== pdpIsModularBYOProduct) {
    t8 = pdpIsModularBYOProduct ? `Build your own ${name.replace(/ modular$/i, "")}` : name;
    $[8] = name;
    $[9] = pdpIsModularBYOProduct;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const finalName = t8;
  let t9;
  if ($[11] !== disableStickyPriceRow || $[12] !== finalName || $[13] !== hideProductLabel || $[14] !== hideRatings || $[15] !== isEditOrder || $[16] !== pdpIsModularBYOProduct || $[17] !== subtitle) {
    t9 = <PDPNameSectionUI name={finalName} subtitle={subtitle} loading={false} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} disableStickyPriceRow={disableStickyPriceRow} hideProductLabel={hideProductLabel} hideRatings={hideRatings} />;
    $[11] = disableStickyPriceRow;
    $[12] = finalName;
    $[13] = hideProductLabel;
    $[14] = hideRatings;
    $[15] = isEditOrder;
    $[16] = pdpIsModularBYOProduct;
    $[17] = subtitle;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
PDPNameSectionInner.propTypes = {
  isEditOrder: PropTypes.bool,
  disableStickyPriceRow: PropTypes.bool,
  hideProductLabel: PropTypes.bool,
  hideRatings: PropTypes.bool
};

// A placeholder that keeps rows the revamp drops would shift the layout when
// the data lands, so the fallback takes the same flags as the resolved rail
const PDPNameSection = t0 => {
  const $ = _c(14);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      disableStickyPriceRow: t1,
      hideRatings: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const disableStickyPriceRow = t1 === undefined ? false : t1;
  const hideRatings = t2 === undefined ? false : t2;
  let t3;
  if ($[4] !== disableStickyPriceRow || $[5] !== hideRatings) {
    t3 = <PDPNameSectionPlaceholder disableStickyPriceRow={disableStickyPriceRow} hideRatings={hideRatings} />;
    $[4] = disableStickyPriceRow;
    $[5] = hideRatings;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== disableStickyPriceRow || $[8] !== hideRatings || $[9] !== props) {
    t4 = <PDPNameSectionInner disableStickyPriceRow={disableStickyPriceRow} hideRatings={hideRatings} {...props} />;
    $[7] = disableStickyPriceRow;
    $[8] = hideRatings;
    $[9] = props;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <SuspenseWithLoader fallback={t3}>{t4}</SuspenseWithLoader>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
PDPNameSection.propTypes = {
  disableStickyPriceRow: PropTypes.bool,
  hideRatings: PropTypes.bool
};
export default PDPNameSection;
function _temp(item) {
  return item.code === "product_subtitle";
}